// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: {
  production: boolean;
  apiBaseUrl: string;
  clientId: string;
  tenantId: string;
  scope: string;
  cacheLocation: string;
  // tslint:disable-next-line: no-string-literal
} = window['__env__'] || {};

// export const environment = {
//   production: false,
//   apiBaseUrl: 'https://nbewdv58h9.execute-api.us-west-2.amazonaws.com/dev',
//   clientId: '45b9ee47-4ed8-4c25-b880-48f9ce648372',
//   tenantId: '36da45f1-dd2c-4d1f-af13-5abe46b99921',
//   cacheLocation: 'localStorage'
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
